import * as yup from "yup";
import { InferType } from "yup";

export const messageImageSchema = yup.object({
  id: yup.string(),
  url: yup.string(),
});

export type MessageImage = InferType<typeof messageImageSchema>;
